import { agentBetaLanguages } from './agent-beta-languages'

/**
 *
 * @param `isSplitTreatmentOn` is a function derived from
 * the context `SplitContext` of the React component
 * `filterAgentsBySplitTreatment` is used in
 *
 * @param `agentsData` is an array of either objects containing a
 * property `type`, or strings, of the agent language key. For
 * a key example see AgentLanguageKey in agent-language.ts
 *
 * @returns an array of either objects or strings that
 * don't exist in the `agentBetaLanguages` mapping
 * or exist with the Split treatment set to "on"
 */
export const filterAgentsBySplitTreatment = (
  isSplitTreatmentOn: (splitName: string) => boolean,
  agentsData: any[]
) => {
  /**
   * Use the split name to update the treatment boolean
   * based on the data we retrieve from Split.io
   */
  if (agentBetaLanguages && Object.keys(agentBetaLanguages).length) {
    for (const language in agentBetaLanguages) {
      if (agentBetaLanguages.hasOwnProperty(language)) {
        agentBetaLanguages[language].isSplitTreatmentOn = isSplitTreatmentOn(
          agentBetaLanguages[language].splitName
        )
      }
    }
  } else {
    return agentsData
  }

  try {
    return agentsData.filter((agent) => {
      const agentToCheck = typeof agent === 'object' ? agent.type : agent
      return agentBetaLanguages.hasOwnProperty(agentToCheck)
        ? agentBetaLanguages[agentToCheck].isSplitTreatmentOn
        : agent
    })
  } catch (error) {
    throw new Error(
      `Unexpected use of filterAgentsBySplitTreatment: \n${error}`
    )
  }
}
